import { create } from 'zustand'

type OverlayStoreT = {
  swipeDownDisabled: boolean
  setSwipeDownDisabled: (disableSwipeDown: boolean) => void
  disableClosingOverlay: boolean
  setDisableClosingOverlay: (disableClosingOverlay: boolean) => void
}

export const useOverlayStore = create<OverlayStoreT>(set => ({
  disableClosingOverlay: false,
  setDisableClosingOverlay: disableClosingOverlay =>
    set({
      disableClosingOverlay,
    }),
  swipeDownDisabled: false,
  setSwipeDownDisabled: swipeDownDisabled => set({ swipeDownDisabled }),
}))
